import { themes } from '@infotech-soe/erp-ui-kit';

import { DEFAULT_THEME } from '../../../constants/theme';
import theme from '../../slices/theme';
import { apiCall, createAppListener } from '../listenerHelpers';

const themeListener = createAppListener();

themeListener.startListening(
  apiCall(
    {
      request: theme.apply,
      success: theme.applySuccess,
      failure: theme.applyFailure,
    },
    async payload => {
      const themeName = payload && payload in themes ? payload : DEFAULT_THEME;
      localStorage.setItem('theme', themeName);
      return { theme: themes[themeName], name: themeName };
    }
  )
);

export default themeListener.middleware;
